import { render, staticRenderFns } from "./CardSelect.vue?vue&type=template&id=0acf1d9a&scoped=true"
import script from "./CardSelect.vue?vue&type=script&lang=js"
export * from "./CardSelect.vue?vue&type=script&lang=js"
import style0 from "./CardSelect.vue?vue&type=style&index=0&id=0acf1d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf1d9a",
  null
  
)

export default component.exports